module.exports = __webpack_public_path__ + "img/button_current_01.1f3fb554.png";